/**
 * Main entry point injected by tag on client website.
 * It injects an iframe including the project.
 */

import { API_OAUTH_CODE_V1, CONTAINER_ID } from './constants';
import { appSrcByEnv, Environment } from './helpers';
import { insertContainer } from './insertContainer';
import { onIframeLoaded } from './onIframeLoaded';
import { PlatformData, PlatformType } from './type';

type AppEnvType = {
  local: Environment.fsLocal | Environment.tagLocal;
  staging: Environment.fsStaging | Environment.tagStaging;
  production: Environment.fsProduction | Environment.tagProduction;
};

const getScriptElement = (src: string): HTMLScriptElement | null =>
  document.querySelector<HTMLScriptElement>(`script[src*="${src}"]`);

export const getAppEnv = ({ local, staging, production }: AppEnvType): Environment => {
  if (process.env.ENV === 'development') {
    return local;
  }

  const fsSrc = getScriptElement('qa-assistant.flagship.io')?.src;
  const abtSrc = getScriptElement('qa-assistant.abtasty.com')?.src;

  const src = fsSrc || abtSrc;
  return src?.includes('staging-') ? staging : production;
};

const loadContainer = () => {
  let appUrlSrc: string = '';
  let apiOauthCodeV1: string | null = null;
  let platformData: PlatformData = {
    type: PlatformType.tag,
  };

  if (window.ABTastyWebSdk || window.flagship) {
    const env = getAppEnv({
      local: Environment.fsLocal,
      staging: Environment.fsStaging,
      production: Environment.fsProduction,
    });
    appUrlSrc = appSrcByEnv[env];
    platformData = { type: PlatformType.fs, fsUrl: appUrlSrc };
  }

  if (window.ABTasty) {
    const env = getAppEnv({
      local: Environment.tagLocal,
      staging: Environment.tagStaging,
      production: Environment.tagProduction,
    });
    appUrlSrc = appSrcByEnv[env];
    apiOauthCodeV1 = new URLSearchParams(window.location.search).get(API_OAUTH_CODE_V1);
    const platformType = platformData.type === PlatformType.fs ? PlatformType.both : PlatformType.tag;
    platformData = { ...platformData, type: platformType, tagUrl: appUrlSrc };
  }
  if (!document.getElementById(CONTAINER_ID))
    insertContainer({ appUrlSrc, onIframeLoaded: onIframeLoaded(appUrlSrc), apiOauthCodeV1, platformData });
};

// Wait document to be interactive before attempting to insert container
const readystatechangeHandler = () => {
  if (document.readyState === 'interactive') {
    loadContainer();
    document.removeEventListener('readystatechange', readystatechangeHandler);
  }
};
if (document.readyState === 'loading') {
  document.addEventListener('readystatechange', readystatechangeHandler);
} else {
  loadContainer();
}
